import React from 'react';
import {TeamProps} from "./Team.props";
import {LearnersOverview} from "../LearnersOverview";
import ChangeWorkSpace from "../../hoc/changeWorkSpace";

const TeamComponent : React.FC<TeamProps> = () => {
  return (
    <>
      <LearnersOverview />
    </>
  );
};

export const Team = ChangeWorkSpace(TeamComponent);
